import styled from "@emotion/styled";
import axios from "axios";
import Cookies from "js-cookie";
import React from "react";
import { useQuery } from "react-query";
import {
  EditBlock,
  Info,
  InfoColumn,
  InfoRow,
  SimpleHeader,
} from "../styled/texts";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import { DAY_ORDER, NUMBER_DAY_MAP } from "../common/mappings";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import EditIcon from "@mui/icons-material/Edit";
import { TabInfo } from "./TabInfo";
import { useSearchParams } from "react-router-dom";
import { useGetTimingsQuery } from "src/api/timingsApiSlice";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  padding: 20px 30px;
`;
const ProfileDataPoints = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

const StyledLabelValueRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const StyledLabel = styled.div`
  flex-basis: 20%;
  color: #3d4253;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const StyledValue = styled.div`
  flex-basis: 80%;
  color: rgba(110, 110, 110, 0.93);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150.188%; /* 24.03px */
`;

const dataIsNotNull = (data) => {
  return data && data.data && data.data.data && data.data.data.workingHours;
};

const prepareJsxOpen = (data) => {
  const formattedData = prepareOpenAndClosedLists(data);
  const list = formattedData.open;
  return list && list.length
    ? list.map((item, idxOuter) => {
        return (
          <div key={`${idxOuter}`}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FiberManualRecordIcon style={{ color: "green" }} />
              <div>{NUMBER_DAY_MAP[item.day]}</div>
            </div>
            <VerticalGap size="5px" />
            <div>
              {item.slots.map((slot, idx) => {
                return (
                  <div
                    key={`${idxOuter}_${idx}`}
                  >{`${slot[0]} - ${slot[1]}`}</div>
                );
              })}
            </div>
            <VerticalGap size="10px" />
          </div>
        );
      })
    : "No data";
};

const prepareJsxClosed = (data) => {
  const formattedData = prepareOpenAndClosedLists(data);
  const list = formattedData.closed;
  return list && list.length
    ? list.map((item) => {
        return (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <FiberManualRecordIcon style={{ color: "red" }} />
              <div>{NUMBER_DAY_MAP[item.day]}</div>
            </div>
          </div>
        );
      })
    : "No data";
};

const prepareOpenAndClosedLists = (workingHours) => {
  const rData = {
    open: [],
    closed: [],
  };

  // if (!dataIsNotNull(data)) {
  //   return rData;
  // }

  // let workingHours = dataIsNotNull(data);

  DAY_ORDER.forEach((number) => {
    if (workingHours[number].length > 0) {
      rData.open.push({ day: number, slots: workingHours[number] });
    } else {
      rData.closed.push({ day: number, slots: workingHours[number] });
    }
  });

  console.log(rData);
  return rData;
};
const Timings = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, isLoading, isSuccess, isError, error } = useGetTimingsQuery();

  if (isLoading) return "loading...";

  if (isError) return "error occured: " + error.message;

  if (data) console.log("open closed data:", data);
  if (isSuccess) {
    return (
      <Container>
        <TabInfo
          editIcon={true}
          editHandler={() => {
            setSearchParams({
              dialog: "open",
              for: "timings",
              action: "edit",
            });
          }}
          header={"Timings"}
          desc={`This page displays the information about your Business Timing. You can view details such as opening hours, working days, and Break Time.`}
        />

        <VerticalGap size={"20px"} />
        <ProfileDataPoints>
          <div>
            <div>Open</div>
            <VerticalGap size="10px" />
            {prepareJsxOpen(data)}
            <VerticalGap size="30px" />
            <div>Closed</div>
            <VerticalGap size="10px" />
            {prepareJsxClosed(data)}
          </div>
        </ProfileDataPoints>
      </Container>
    );
  }
};

export { Timings };
